import { useMap } from 'react-leaflet';
import L from 'leaflet';
import React from 'react';

// Função utilitária para validar coordenadas plausíveis no Brasil
function isCoordInBrazil([lng, lat]) {
  return (
    typeof lng === 'number' &&
    typeof lat === 'number' &&
    lng >= -75 &&
    lng <= -30 &&
    lat >= -35 &&
    lat <= 5
  );
}

export default function FitBoundsHandler({ themeGeometries, forceFitBounds }) {
  const map = useMap();

  React.useEffect(() => {
    //  console.log('[FitBoundsHandler] Iniciando com themeGeometries:', {
    //    tipoThemeGeometries: typeof themeGeometries,
    //    temas: Object.keys(themeGeometries || {}),
    //    totalTemas: Object.keys(themeGeometries || {}).length,
    //    totalGeometrias: Object.values(themeGeometries || {}).flat().length,
    //    forceFitBounds
    //  });

    const timeout = setTimeout(() => {
      const themeEntries = Object.entries(themeGeometries || {});
      const priorityEntries = themeEntries.filter(([tema]) => {
        const normalized = String(tema || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase();
        return normalized.includes('AREA DO IMOVEL') || normalized === 'SIGEF';
      });

      const nonMunicipioEntries = themeEntries.filter(([tema]) => {
        const normalized = String(tema || '')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toUpperCase();
        return normalized !== 'MUNICIPIO';
      });

      const entriesToFit =
        priorityEntries.length > 0
          ? priorityEntries
          : nonMunicipioEntries.length > 0
            ? nonMunicipioEntries
            : themeEntries;

      const allGeoms = [];
      entriesToFit.forEach(([, geoms]) => {
        if (!geoms || !geoms.length) return;

        //  console.log('[FitBoundsHandler] Processando grupo de geometrias:', {
        //    quantidade: geoms.length,
        //    tipo: typeof geoms[0],
        //    amostra: geoms[0] ? (typeof geoms[0] === 'string' ? geoms[0].substring(0, 50) + '...' : '(objeto)') : null
        //  });

        geoms.forEach((g) => {
          if (!g) return;

          try {
            // Tenta extrair a geometria conforme o formato (string ou objeto)
            let geometry = typeof g === 'string' ? JSON.parse(g) : g;

            // Se for feature completa, extrai apenas a geometria
            if (geometry.type === 'Feature' && geometry.geometry) {
              geometry = geometry.geometry;
            }

            if (geometry && geometry.type && geometry.coordinates) {
              allGeoms.push(geometry);
            }
          } catch (err) {
            console.warn('[FitBoundsHandler] Erro ao processar geometria:', err);
          }
        });
      });

      // console.log('[FitBoundsHandler] Geometrias coletadas:', allGeoms.length);

      // 2. Filtra apenas as geometrias plausíveis para fitBounds
      const validGeoms = [];
      const filteredOut = [];
      allGeoms.forEach((g) => {
        let firstCoord = null;
        if (g.type === 'Polygon' && g.coordinates?.length > 0) {
          firstCoord = g.coordinates[0][0];
        } else if (g.type === 'MultiPolygon' && g.coordinates?.length > 0) {
          firstCoord = g.coordinates[0][0][0];
        }
        if (firstCoord && isCoordInBrazil(firstCoord)) {
          validGeoms.push(g);
        } else {
          filteredOut.push({ type: g.type, firstCoord });
        }
      });

      // 3. Monta FeatureCollection para o Leaflet
      const featureCollection = {
        type: 'FeatureCollection',
        features: validGeoms.map((geometry) => ({
          type: 'Feature',
          geometry,
          properties: {},
        })),
      };

      // 4. Calcula bounds e ajusta o mapa
      const bounds = L.geoJSON(featureCollection).getBounds();
      if (bounds.isValid()) {
        map.fitBounds(bounds, { maxZoom: 17 });
        if (filteredOut.length > 0) {
          // console.warn(`[FitBoundsHandler] ${filteredOut.length} geometrias ignoradas no fitBounds por coordenadas fora do Brasil. Exemplo:`, filteredOut.slice(0,2));
        }
      } else {
        // Log para diagnóstico
        // console.warn('[FitBoundsHandler] Bounds não são válidos. Nenhuma geometria visível para ajustar o mapa. Ignoradas:', filteredOut);
      }
    }, 200); // Delay para garantir layout estável
    return () => clearTimeout(timeout);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(themeGeometries), forceFitBounds, map]);
  return null;
}
